'use strict'

/**
 * Constants file with the endpoints used by users module to call a REST-services of the backend API.
 *
 * @type {number}
 *
 * @author Valentin Agudelo Aquite
 * @since 20/02/2020 01:01 PM
 * @version 1.0.0
 */

/* Backend endpoints */
const ROOT_URI = `${process.env.VUE_APP_API_URL}`
const ROOT_WEB_URI = `${process.env.VUE_APP_WEB_URL}`

export const TRAER_OBRAS = `${ROOT_URI}obras/`
export const TRAER_TIPOS_DOCUMENTOS = `${ROOT_URI}tipos-documento/`
export const TRAER_PAISES = `${ROOT_URI}paises/`
export const TRAER_TIPO_MONEDA = `${ROOT_URI}parametros-generales/tipos-moneda`
export const GUARDAR_DONACION = `${ROOT_URI}publicos/donaciones/`
export const CODIGO_NIT = 'NIT'
/* */
export const URL_RESPONSE_EPAYCO = `${ROOT_WEB_URI}confirmacion-de-pagos`
export const WEBHOOK_CONFIRMACION_EPAYCO = `${ROOT_URI}epayco-webhooks/confirmacion-transaccion`

export const SERVICIO_PASARELA_DONACION_CODIGO = 1

export const DEFAULT_FIELDS_DISABLED = {
  campana: false,
  tipoDocumento: false,
  obra: false,
  numeroDocumento: false,
  nombre: false,
  apellido: false,
  razonSocial: false,
  correoElectronico: false,
  confirmacionCorreoElectronico: false,
  telefono: false,
  valor: false,
  pais: false,
  ciudad: false,
  direccion: false,
  tipoMoneda: false
}

export const CONFIGURATION_VALIDATE_QUERY_PARAMETERS = [
  {
    data: 'documento',
    query: 'numeroDocumento',
    valida: false
  },
  {
    data: 'nombres',
    query: 'nombre',
    valida: false
  },
  {
    data: 'apellidos',
    query: 'apellido',
    valida: false
  },
  {
    data: 'correo',
    query: 'correoElectronico',
    valida: false
  },
  {
    data: 'correo',
    query: 'confirmacionCorreoElectronico',
    valida: false
  },
  {
    data: 'ciudad',
    query: 'ciudad',
    valida: false
  },
  {
    data: 'direccion',
    query: 'direccion',
    valida: false
  },
  {
    data: 'telefono',
    query: 'telefono',
    valida: false
  },
  {
    data: 'razonSocial',
    query: 'razonSocial',
    valida: false
  },
  {
    data: 'tipoMoneda',
    query: 'tipoMoneda',
    valida: true
  },
  {
    data: 'valor',
    query: 'valor',
    valida: true
  }
]

export const FIELDS_DEFAULT_EPAYCO_CHECKOUT = {
  SIN_IVA: '0',
  EXTERNAL_CHECKOUT: 'false'
}
